import React, { useCallback, useRef } from "react";
import { Modal } from "react-bootstrap";
import html2canvas from "html2canvas";

const MyTeamDownloadModal = (props) => {
  const modalContentRef1 = useRef(null);
  const captureImage = useCallback(() => {
    const targetElement = modalContentRef1.current;
    if (modalContentRef1.current) {
      html2canvas(targetElement, { useCORS: true }).then((canvas) => {
        const image = canvas.toDataURL("image/png");

        // Create a download link
        const downloadLink = document.createElement("a");
        downloadLink.href = image;
        downloadLink.download = `MyClubtap-${props?.teamModalData?.full_name}`;

        // Append the link to the document and trigger a click event
        document.body.appendChild(downloadLink);
        downloadLink.click();

        // Remove the link from the document
        document.body.removeChild(downloadLink);
      });
    }
  }, [props.teamModalData?.full_name]);

  const { loadingStates, handleMyTeamCardModalClose } = props;

  const handleModalEntered = useCallback(() => {
    if (loadingStates["my_team_card"] === false) {
      captureImage();
      handleMyTeamCardModalClose();
    }
  }, [loadingStates, captureImage, handleMyTeamCardModalClose]);

  return (
    <>
      <Modal
        show={props.showTeamCardModal}
        onHide={() => props.setShowTeamCardModal(false)}
        size="lg"
        id="playermoreinfo1"
        onEntered={handleModalEntered}
      >
        <div ref={modalContentRef1}>
          <div className="gamevideo">
            <figure>
              <img src="/images/video-img.jpg" alt="img" />
            </figure>
          </div>
          <figure className="user-profile">
            {props.teamModalData?.clubDetails?.logo &&
              props.teamModalData?.clubDetails?.logo && (
                <img
                  src={`${process.env.REACT_APP_UPLOAD_URL}game_logo/${props.teamModalData?.clubDetails?.logo}`}
                  width="70"
                  height="70"
                  alt="img"
                />
              )}
            {!props.teamModalData?.clubDetails ||
              (!props.teamModalData?.clubDetails?.logo && (
                <img src="images/brand-logo.png" alt="img" />
              ))}
          </figure>
          <div className="profile-content">
            <h4>{props?.teamModalData?.full_name}</h4>
            <div className="admindetail">
              <span>
                <strong>
                  {" "}
                  <i
                    className="fas fa-tshirt"
                    aria-hidden="true"
                    style={{ color: "#CA1744" }}
                  ></i>
                  Team
                </strong>

                {props?.teamModalData?.my_team_name}
              </span>
              <span>
                <strong>
                  <i
                    className="fas fa-dice-d20"
                    aria-hidden="true"
                    style={{ color: "#CA1744" }}
                  ></i>
                  Overall Points
                </strong>

                {props?.teamModalData?.rank_points?.overall_pt
                  ? parseFloat(props?.teamModalData?.rank_points?.overall_pt)
                  : "-"}
              </span>
              <span>
                <strong>
                  {" "}
                  <i
                    className="fas fa-trophy"
                    aria-hidden="true"
                    style={{ color: "#CA1744" }}
                  ></i>{" "}
                  Overall Rank
                </strong>

                {props.teamModalData?.rank_points?.overall_rank ?? "-"}
              </span>

              <span>
                <strong>
                  <i
                    className="fas fa-circle-notch"
                    aria-hidden="true"
                    style={{ color: "#CA1744" }}
                  ></i>{" "}
                  Current Round
                </strong>
                {props.teamModalData?.current_round}
              </span>
              <span>
                <strong>
                  {" "}
                  <i
                    className="fas fa-dice-d6"
                    aria-hidden="true"
                    style={{ color: "#CA1744" }}
                  ></i>{" "}
                  Round Points
                </strong>

                {props.teamModalData?.rank_points?.gw_pt
                  ? parseFloat(props.teamModalData?.rank_points?.gw_pt)
                  : "-"}
              </span>
              <span>
                <strong>
                  {" "}
                  <i
                    className="fas fa-chess-king"
                    aria-hidden="true"
                    style={{ color: "#CA1744" }}
                  ></i>{" "}
                  Round Rank
                </strong>

                {props.teamModalData?.rank_points?.gw_rank ?? "-"}
              </span>

              <span>
                <strong>
                  {" "}
                  <i
                    className="fas fa-chart-bar"
                    aria-hidden="true"
                    style={{ color: "#CA1744" }}
                  ></i>{" "}
                  Average Points
                </strong>

                {props.teamModalData?.avgPoints
                  ? parseFloat(props.teamModalData?.avgPoints)
                  : "-"}
              </span>
              <span>
                <strong>
                  {" "}
                  <i
                    className="fas fa-minus-square"
                    aria-hidden="true"
                    style={{ color: "#CA1744" }}
                  ></i>
                  Trades Used
                </strong>

                {props.teamModalData?.game_info_block_data?.trade_used}
              </span>
              <span>
                <strong>
                  {" "}
                  <i
                    className="fas fa-plus-square"
                    aria-hidden="true"
                    style={{ color: "#CA1744" }}
                  ></i>
                  Trades Left
                </strong>

                {props.teamModalData?.game_info_block_data?.remains_trades}
              </span>

              <span>
                <strong>
                  <i
                    className="fas fa-coins"
                    aria-hidden="true"
                    style={{ color: "#CA1744" }}
                  ></i>
                  Team Value
                </strong>
                {props.teamModalData?.clubDetails?.default_salary_symbol}
                {(
                  props.teamModalData?.budget_left +
                  props.teamModalData?.budget_used
                ).toFixed(2)}
                {props.teamModalData?.clubDetails?.default_salary_symbol
                  ? "m"
                  : ""}
              </span>
              <span>
                <strong>
                  <i
                    className="fas fa-minus-square"
                    aria-hidden="true"
                    style={{ color: "#CA1744" }}
                  ></i>
                  Budget Used
                </strong>

                {props.teamModalData?.clubDetails?.default_salary_symbol}
                {props.teamModalData?.budget_used}
                {props.teamModalData?.clubDetails?.default_salary_symbol
                  ? "m"
                  : ""}
              </span>
              <span>
                <strong>
                  {" "}
                  <i
                    className="fas fa-plus-square"
                    aria-hidden="true"
                    style={{ color: "#CA1744" }}
                  ></i>{" "}
                  Budget Left
                </strong>

                {props.teamModalData?.clubDetails?.default_salary_symbol}
                {props.teamModalData?.budget_left}
                {props.teamModalData?.clubDetails?.default_salary_symbol
                  ? "m"
                  : ""}
              </span>

              <span>
                <strong>
                  {" "}
                  <i
                    className="fas fa-shield-alt"
                    aria-hidden="true"
                    style={{ color: "#CA1744" }}
                  ></i>{" "}
                  Game
                </strong>

                {props.teamModalData?.clubDetails?.game_name}
              </span>
            </div>

            {/* <p>Fantasy Hub: Fantasy Hub Name</p> */}
          </div>
        </div>
      </Modal>
    </>
  );
};

export default MyTeamDownloadModal;
